import { __decorate } from "tslib";
import React, { Component } from 'react';
import ConfigContext from 'choerodon-ui/lib/config-provider/ConfigContext';
import { observer } from 'mobx-react';
import { action, observable, runInAction } from 'mobx';
import autobind from '../_util/autobind';
import { $l } from '../locale-context';
import DataSet from '../data-set/DataSet';
import message from '../message';
import { FieldType } from '../data-set/enum';
import Form from '../form/Form';
import SelectBox from '../select-box/SelectBox';
import Option from '../option/Option';
import TextField from '../text-field';
import Button from '../button/Button';
import VerifySlider from './VerifySlider';
import CountDownButton from './CountDownButton';
import { ButtonColor } from '../button/enum';
import { ValueChangeAction } from '../text-field/enum';
let SecretFieldView = class SecretFieldView extends Component {
    constructor(props, context) {
        super(props, context);
        runInAction(() => {
            this.setFlag('verify');
            this.setVerifyTypeObj();
            this.setFormDs();
            this.setCaptchaKey('');
            this.setCaptcha('');
            this.setValidate(true);
        });
    }
    static get contextType() {
        return ConfigContext;
    }
    get prefixCls() {
        const { context } = this;
        return context.getProPrefixCls('secret-field');
    }
    // 滑块拖到最右
    handleSuccess() {
        const { countDown } = this.props;
        const { context, formDs } = this;
        const type = formDs?.current?.get('verifyType');
        // 发送信息以获取验证码
        const secretFieldFetchVerifyCode = context.getConfig('secretFieldFetchVerifyCode');
        if (secretFieldFetchVerifyCode) {
            secretFieldFetchVerifyCode(type).then(res => {
                if (res.success) {
                    message.success(res.message);
                    this.setCaptchaKey(res.captchaKey);
                    // 验证码倒计时
                    countDown.start();
                    countDown.setVerifyType(type);
                }
                else {
                    message.error(res.message);
                }
                setTimeout(() => {
                    this.setFlag('verify');
                }, 500);
            }).catch(_e => this.setFlag('verify'));
        }
    }
    // 下一步
    handleGoToEdit() {
        const { name, token = '' } = this.props;
        // 编辑-校验验证码，返回原始值
        const { captchaKey, captcha, context } = this;
        const secretFieldQueryData = context.getConfig('secretFieldQueryData');
        const type = this.formDs?.current?.get('verifyType');
        const params = { type, _token: token, fieldName: name, captchaKey, captcha, action: 'edit' };
        if (secretFieldQueryData) {
            secretFieldQueryData(params).then(res => {
                if (res?.failed) {
                    // 校验失败
                    return;
                }
                // 编辑-返回原始数据
                this.formDs?.current?.set(name, res);
                this.setFlag('edit');
            });
        }
        else {
            this.setFlag('edit');
        }
    }
    // 确定可查看
    handleQuery() {
        const { name, token = '', onChange, modal, record } = this.props;
        // 查看-校验验证码，返回原始值
        const { captchaKey, captcha, context } = this;
        const secretFieldQueryData = context.getConfig('secretFieldQueryData');
        const type = this.formDs?.current?.get('verifyType');
        const params = { type, _token: token, fieldName: name, captchaKey, captcha, action: 'query' };
        if (secretFieldQueryData) {
            return secretFieldQueryData(params).then(res => {
                if (res?.failed) {
                    // 校验失败
                    return;
                }
                // 查看-返回原始数据
                if (onChange) {
                    if (res) {
                        onChange(res);
                    }
                    else {
                        onChange('');
                    }
                }
                if (modal) {
                    modal.close();
                    record?.setState({ [`_secretField_queryFlag_${name}`]: true });
                }
            });
        }
    }
    // 正则string处理
    generatePattern(pattern) {
        if (pattern instanceof RegExp) {
            return pattern;
        }
        const begin = pattern.startsWith('^') ? '' : '^';
        const end = pattern.endsWith('$') ? '' : '$';
        return new RegExp(`${begin}${pattern}${end}`);
    }
    // 确定修改
    handleEdit() {
        const { name, token = '', onChange, modal, pattern, required } = this.props;
        const { context } = this;
        const editValue = this.formDs?.current?.get(name);
        if (pattern) {
            const newPattern = this.generatePattern(pattern);
            if (newPattern.test(editValue) === false) {
                // 正则校验不通过
                this.setValidate(false);
                return;
            }
        }
        if (required) {
            if (!editValue) {
                return;
            }
        }
        // 接口查询重置值
        const secretFieldSaveData = context.getConfig('secretFieldSaveData');
        const params = { _token: token, fieldName: name, value: editValue };
        if (secretFieldSaveData) {
            return secretFieldSaveData(params).then(res => {
                // 校验失败
                if (res?.failed) {
                    return;
                }
                // 编辑-返回修改数据
                if (onChange) {
                    if (res) {
                        onChange(res);
                    }
                    else if (!res) {
                        onChange('');
                    }
                }
                if (modal) {
                    modal.close();
                }
            });
        }
    }
    // 取消
    handleCancel() {
        // 清空formDs值
        // 关闭弹窗
        const { modal } = this.props;
        if (modal) {
            modal.close();
        }
    }
    setFormDs() {
        const { name, label, pattern, required, countDown } = this.props;
        const { verifyTypeObj } = this;
        const { verifyType } = countDown;
        let initData = [];
        let verifyValue = '';
        // 传入验证方式时，设置初始值
        if (verifyType) {
            verifyTypeObj.forEach(item => {
                if (item.type === verifyType) {
                    verifyValue = item.value;
                }
            });
        }
        if (verifyTypeObj.length > 0) {
            initData = [{ 'verifyType': verifyType || verifyTypeObj[0].type, 'verifyNumber': verifyType ? verifyValue : verifyTypeObj[0].value || '' }];
        }
        this.formDs = new DataSet({
            autoCreate: true,
            data: initData,
            fields: [
                {
                    name: 'verifyType',
                    type: FieldType.string,
                    label: $l('SecretField', 'verify_type'),
                },
                {
                    name: 'verifyNumber',
                    type: FieldType.string,
                    label: $l('SecretField', 'verify_value'),
                },
                {
                    name: 'verifyCode',
                    type: FieldType.string,
                    label: $l('SecretField', 'verify_code'),
                },
                {
                    name,
                    type: FieldType.string,
                    label,
                    pattern,
                    required,
                },
            ],
            events: {
                update: this.handleFormUpdate,
            },
        });
    }
    setCaptchaKey(value) {
        this.captchaKey = value;
    }
    setCaptcha(value) {
        this.captcha = value;
    }
    setValidate(value) {
        this.validate = value;
    }
    setFlag(value) {
        this.flag = value;
    }
    setVerifyTypeObj() {
        const { context } = this;
        // 从配置项获取验证方式
        const secretFieldTypesConfig = context.getConfig('secretFieldTypes');
        if (secretFieldTypesConfig) {
            this.verifyTypeObj = secretFieldTypesConfig();
        }
        else {
            this.verifyTypeObj = [];
        }
    }
    handleFormUpdate({ name, value }) {
        const { verifyTypeObj } = this;
        // 修改验证方式时，自动填充验证号码
        if (verifyTypeObj.length > 0 && name === 'verifyType') {
            verifyTypeObj.forEach(item => {
                if (item.type === value) {
                    this.formDs?.current?.set('verifyNumber', item.value);
                }
            });
        }
        if (name === 'verifyCode') {
            this.setCaptcha(value);
        }
    }
    handleVerifySliderCancel() {
        this.setFlag('verify');
    }
    handleClickButton() {
        this.setFlag('slider');
    }
    render() {
        const { flag, captcha, verifyTypeObj, prefixCls, validate, formDs } = this;
        const { readOnly, label, name, countDown, restrict } = this.props;
        const { count } = countDown;
        return (React.createElement("div", { className: `${prefixCls}-modal` },
            flag !== 'slider' && (React.createElement(Form, { className: `${prefixCls}-modal-form`, dataSet: this.formDs, columns: 4, labelWidth: "auto" },
                flag === 'verify' && (React.createElement(React.Fragment, null,
                    React.createElement(SelectBox, { name: "verifyType", colSpan: 4, disabled: count }, verifyTypeObj?.map(item => React.createElement(Option, { value: item.type, key: item.type }, item.name))),
                    React.createElement(TextField, { name: "verifyNumber", colSpan: 4, disabled: true }),
                    React.createElement(TextField, { name: "verifyCode", colSpan: 3, valueChangeAction: ValueChangeAction.input }),
                    React.createElement(CountDownButton, { onClick: this.handleClickButton, countDown: countDown, verifyNumber: formDs.current.get('verifyNumber') }),
                    React.createElement("td", { className: `${prefixCls}-modal-btns`, colSpan: 4 },
                        React.createElement(Button, { onClick: this.handleCancel }, $l('SecretField', 'cancel')),
                        readOnly ? (React.createElement(Button, { onClick: this.handleQuery, className: `${prefixCls}-modal-raised-btn`, disabled: !captcha, color: ButtonColor.primary }, $l('SecretField', 'ok_btn'))) : (React.createElement(Button, { onClick: this.handleGoToEdit, className: `${prefixCls}-modal-raised-btn`, disabled: !captcha, color: ButtonColor.primary }, $l('SecretField', 'next_step')))))),
                flag === 'edit' && (React.createElement(React.Fragment, null,
                    React.createElement(TextField, { name: name, colSpan: 4, restrict: restrict }),
                    React.createElement("td", { colSpan: 4, className: `${prefixCls}-modal-edit-btns` },
                        !validate &&
                            React.createElement(React.Fragment, null,
                                React.createElement("p", { className: `${prefixCls}-modal-validate` }, $l('SecretField', 'type_mismatch', { label })),
                                React.createElement("br", null)),
                        React.createElement(Button, { onClick: this.handleCancel }, $l('SecretField', 'cancel')),
                        React.createElement(Button, { onClick: this.handleEdit, color: ButtonColor.primary }, $l('SecretField', 'ok_btn'))))))),
            flag === 'slider' && (React.createElement(VerifySlider, { onCancel: this.handleVerifySliderCancel, onSuccess: this.handleSuccess }))));
    }
};
SecretFieldView.displayName = 'SecretFieldView';
__decorate([
    autobind
], SecretFieldView.prototype, "handleSuccess", null);
__decorate([
    autobind
], SecretFieldView.prototype, "handleGoToEdit", null);
__decorate([
    autobind
], SecretFieldView.prototype, "handleQuery", null);
__decorate([
    autobind
], SecretFieldView.prototype, "handleEdit", null);
__decorate([
    autobind
], SecretFieldView.prototype, "handleCancel", null);
__decorate([
    observable
], SecretFieldView.prototype, "formDs", void 0);
__decorate([
    action
], SecretFieldView.prototype, "setFormDs", null);
__decorate([
    observable
], SecretFieldView.prototype, "captchaKey", void 0);
__decorate([
    action
], SecretFieldView.prototype, "setCaptchaKey", null);
__decorate([
    observable
], SecretFieldView.prototype, "captcha", void 0);
__decorate([
    action
], SecretFieldView.prototype, "setCaptcha", null);
__decorate([
    observable
], SecretFieldView.prototype, "validate", void 0);
__decorate([
    action
], SecretFieldView.prototype, "setValidate", null);
__decorate([
    observable
], SecretFieldView.prototype, "flag", void 0);
__decorate([
    action
], SecretFieldView.prototype, "setFlag", null);
__decorate([
    observable
], SecretFieldView.prototype, "verifyTypeObj", void 0);
__decorate([
    action
], SecretFieldView.prototype, "setVerifyTypeObj", null);
__decorate([
    autobind
], SecretFieldView.prototype, "handleFormUpdate", null);
__decorate([
    autobind
], SecretFieldView.prototype, "handleVerifySliderCancel", null);
__decorate([
    autobind
], SecretFieldView.prototype, "handleClickButton", null);
SecretFieldView = __decorate([
    observer
], SecretFieldView);
export default SecretFieldView;
